import { CategoryFilterEffects } from "./category-filter.effects";

export const effects: any[] = [CategoryFilterEffects];

export * from "./category-filter.effects";
